import { DOWNLOADFILE, GET } from "../../API/get";
import { POST } from "../../API/post";
import { FORMPUT, PUT } from "../../API/put";
import { setBookAgainDetails } from "../../storage";

export const fetchJobDetails = async (job_id) => {
    const response = await GET(`get-job-details/${job_id}`);
    return response?.status === "Success" ? response : null;
}

export const fetchCancelReasons = async () => {
    const response = await GET("customer/cancel/reasons");
    return response?.status === "Success" ? response : null;
};


export const findFtm = async (job_id) => {
    const response = await GET(`find-ftm/${job_id}`);
    return response?.status === "Success" ? response : null;
};

export const findRequestDetails = async (job_id) => {
    const response = await GET(`v3/ftm-requests/job/${job_id}`);
    return response?.status === "Success" ? response : null;
};

export const downloadInvoice = async (job_id) => {
    const response = await DOWNLOADFILE(`v3/jobs/${job_id}/invoice/CUSTOMER_JOB_INVOICE_PAYMENT_SUMMARY?download=true`);
    return response?.status === "Success" ? response : null;
}

export const findJobCancelReasons = async (job_id) => {
    const response = await GET(`job/cancel/reasons/${job_id}`);
    return response?.status === "Success" ? response : null;
};

export const submitSignature = async (job_id, file, description) => {
    const response = await FORMPUT("v3/jobs/signature", {
        type: "CUSTOMER",
        job_id: job_id,
        signature_file: file,
        description
    });
    return response?.status === "Success" ? response : null;
}

export const downloadJobsheet = async (job_id) => {
    const response = await DOWNLOADFILE(`v3/jobs/${job_id}/jobsheet?download=true`);
    return response?.status === "Success" ? response : null;
}

export const customerCancelJob = async (job_id) => {
    const response = await PUT("v2/customer-cancel-job", { job_id });
    return response?.status === "Success" ? response : null;
};

export const submitJobCancelReason = async (job_id, reason_id, reason) => {
    const response = await POST("customer/cancel/reasons", {
        reason_id: reason_id,
        job_id: job_id,
        reason: reason
    });
    return response?.status === "Success" ? response : null;
}

export const fetchJobStatusHistory = async (job_id) => {
    const response = await GET(`v3/job-status-change-logs/${job_id}`);
    return response?.status === "Success" ? response : null;
};

export const fetchRequestPreSignSupport = async (job_id) => {
    const response = await GET(`v3/jobs/request-pre-sign-support/${job_id}`);
    return response?.status === "Success" ? response : null;
};

export const customerCancelJobByRescheduleJob = async (job_id, reschedule_job_id) => {
    await setBookAgainDetails(job_id);

    const response = await PUT(`v3/reschedule-jobs/${reschedule_job_id}/job-cancel`);
    return response?.status === "Success" ? response : null;
};

export const fetchJobStatusList = async () => {
    const response = await GET(`v3/job-status`);
    return response?.status === "Success" ? response : null;
};
